<template>
    <div class="flex">
        <div class="deliveryAddressCard__action deliveryAddressCard__action--no-underline w-8/12">
            <p class="no-margin" v-text="$t(`${headingKey}`)"></p>
        </div>
        <div class="deliveryAddressCard__action deliveryAddressCard__action--no-underline w-4/12 border-l">
            <p class="p-0 m-0 text-center w-full">
                £{{ price | priceNoInsignificantTrailingZeros }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeliveryPrice',
    props: {
        price: {
            required: true,
            type: Number,
        },
        headingKey: {
            required: true,
            type: String,
        },
    },
    filters: {
        priceNoInsignificantTrailingZeros(value) {
            return Number(value).toString();
        },
    },
};
</script>
